import styled from 'styled-components';
import { Button } from '@dsny/dsny-component-library';
import { device } from 'src/styles/global';

export interface Props {
  hasComparisonOn?: boolean;
}

export const AddNewTrackWrapper = styled.div<Props>`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 16px;

  @media ${device.mobile} {
    display: none;
  }

  @media ${device.tablet} {
    display: none;
  }

  @media ${device.ipad} {
    width: 100%;
  }
`;

export const AddNewTrackButton = styled(Button)`
  width: 100%;
  svg {
    width: 18px;
    height: 18px;
    padding-bottom: 2px;
  }
`;
